module.exports = __webpack_public_path__ + "img/default.f2656d43.svg";